import { Farm } from '@/common/interface/farm.data.model';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FarmService } from '@services/farm.service';
import { ToastrService } from 'ngx-toastr';
interface SensorSelection {
  sensorId: number | null;
}
@Component({
  selector: 'app-profile-dashboard',
  templateUrl: './profile-dashboard.component.html',
  styleUrl: './profile-dashboard.component.scss'
})
export class ProfileDashboardComponent {
  public authToken: any;
  public displayfarm: boolean = false;
  //public selectedFarmId: number | null = null;
  public currentFarmId: number | null = null;
  public currentFarmHouseId: number | null = null;
  public currentPartitionId: number | null = null;
  public sensorsList: any[] = [];
  public farmHouseSensorsList: any[] = [];
  userDetail: any;
  public farms: Farm[] = [];
  public displaySensorPopup: boolean = false;
  public sensors: SensorSelection[] = [{ sensorId: null }];
  public selectedFarmId: number | null = null;
  constructor(private farmService: FarmService, private toaster: ToastrService,private router: Router) {

  }
  ngOnInit(): void {
    this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
    this.loadFarms();
    this.loadSensorsList();
  }

  loadFarms(): void {
    this.farmService.getFarmDashboardList(this.userDetail.id).subscribe((data: Farm[]) => {
      this.farms = data;
      if (this.farms.length > 0) {
        this.selectedFarmId = this.farms[0].id; // Set the first farm as active
      }
      else {
        this.displayfarm = true;
      }
    });
  }
  loadSensorsList(): void {
    this.farmService.getSensorsList().subscribe((sensors) => {
      this.sensorsList = sensors; // Assuming the service returns an array of sensors
    });
  }
  GetFarmHouseSensorsList(farmId: number): void {
    this.farmService.getFarmSensorsListById(farmId).subscribe((sensors) => {
      this.farmHouseSensorsList = sensors; // Assuming the service returns an array of sensors
      console.log("bb", this.farmHouseSensorsList);
    });
  }
  closeDialog(): void {
    this.displayfarm = false;
  }
  onCloseFarmDialog() {
    this.displayfarm = false;
    this.loadFarms();
  }
  selectFarm(farmId: number): void {
    this.selectedFarmId = farmId;
  }
  getFarmhouseCount(): number {
    return this.farms.reduce((count, farm) => count + farm.farmHouses.length, 0);
  }
  openAddSensorPopup(farmId: number, farmHouseId: number, partitionId: number): void {
    this.GetFarmHouseSensorsList(partitionId);
    this.currentFarmId = farmId;
    this.currentFarmHouseId = farmHouseId;
    this.currentPartitionId = partitionId;
    this.sensors = [{ sensorId: null }]; // Reset sensors array when popup opens
    this.displaySensorPopup = true;
  }

  addSensor(): void {
    this.sensors.push({ sensorId: null });
  }

  removeSensor(index: number): void {
    this.sensors.splice(index, 1);
  }

  closePopup(): void {
    this.displaySensorPopup = false;
  }

  saveSensors(): void {
    const payload = this.sensors
      .filter(sensor => sensor.sensorId !== null) // Only include fully filled sensors
      .map(sensor => ({
        farmId: this.currentFarmId,
        farmHouseId: this.currentFarmHouseId,
        partitionId: this.currentPartitionId,
        sensorId: sensor.sensorId,
        //deviceId: sensor.deviceId
      }));
    console.log(payload);
    this.farmService.addFarmHouseSensor(payload).subscribe({
      next: (response) => {
        setTimeout(() => {
          this.displaySensorPopup = false;
          this.GetFarmHouseSensorsList(this.currentFarmId);
          this.toaster.success("Sensors Added Successfully");
        }, 2000);
      },
      error: (error) => {
        setTimeout(() => {
          //this.isAuthLoading = false;
          // this.loaderService.hideLoader();
          // Handle login error
          this.toaster.error(error.error);

        }, 2000);
      }
    });
  }
  editFarm(){
    this.router.navigate(['/edit-farm', this.selectedFarmId]);
    console.log(this.selectedFarmId);
  }
}
